import MainLayout from "Layout/MainLayout";
import React from "react";
import { Navigate } from "react-router-dom";

function PrivateRoute(props) {
  const { token } = props;
  return !token ? (
    <Navigate to={"/login"} />
  ) : (
    <MainLayout>{props?.element}</MainLayout>
  );
}

export default PrivateRoute;
